import React from 'react'
import I18n from '../../resources/i18n/I18n'
import Logo from '../logo/Logo'
import Title from '../typo/Title'
import './help.scss'

const Help = () => {
  return (
    <div className="help">
      <Logo />
      <div className="container">
        <div className="row">
          <Title text={I18n.t('HelpTitle')} />
        </div>
        <p>
          Pour toutes vos questions, contactez notre assistance{' '}
          <a href="https://ush.atlassian.net/servicedesk/customer/portal/325/group/453/create/705" target="_blank" rel="noopener noreferrer">
            ORFI &amp; Suivi Des Incivilités - Support aux bailleurs - Jira Service Management
          </a>
        </p>
        <p>
          En savoir plus sur ORFI{' '}
          <a
            href="https://www.union-habitat.org/centre-de-ressources/politique-de-la-ville-urbanisme/orfi-outil-de-recueil-des-faits-d-incivilites"
            target="_blank"
            rel="noopener noreferrer"
          >
            ORFI - Outil de recueil des faits d&apos;incivilités | L&apos;Union sociale pour l&apos;habitat
          </a>
        </p>
        <p>
          En savoir plus sur Suivi Des Incivilités{' '}
          <a
            href="https://www.union-habitat.org/centre-de-ressources/politique-de-la-ville-urbanisme/sdi-suivi-des-incivilites"
            target="_blank"
            rel="noopener noreferrer"
          >
            SDI - Suivi des Incivilités | L&apos;Union sociale pour l&apos;habitat
          </a>
        </p>
      </div>
    </div>
  )
}

export default Help
